import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class RegistrationCodesApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/registration-codes'
    }
}

export default new RegistrationCodesApiClient()
